import { _ } from "~/i18n";
import { node } from "~/util/dom";
import { standardDistanceFormat, standardTimeFormat } from "~/util/format";

interface ISummary {
	total_time: number | string;
	total_count: number | string;
	total_length: number | string;
}

function createItem(caption: string, distanceUnit?: string) {
	const container = node("div", { className: "activities-summary__item" });
	const title = node("span", { className: "activities-summary__itemTitle", textContent: caption });
	const value = node("span", { className: "activities-summary__itemValue" });
	const unit = node("span", { className: "activities-summary__itemUnit", textContent: distanceUnit || "" });

	container.append(title, value, unit);

	return {
		container,
		value,
		unit,
	};
}

type TCreateItem = ReturnType<typeof createItem>;

export default class ActivitiesSummary {
	_container: HTMLDivElement;

	_items: {
		time: TCreateItem;
		count: TCreateItem;
		distance: TCreateItem;
	};

	_preventAnimation: boolean;

	constructor() {
		const container = node("div", { className: "activities-summary" });

		this._items = {
			time: createItem(_("mymap.activity.filter.totalTime"), _("mymap.activity.filter.hours")),
			count: createItem(_("mymap.activity.filter.totalCount")),
			distance: createItem(_("mymap.activity.filter.totalDistance")),
		};
		this._container = container;
		this._container.append(this._items.time.container, this._items.count.container, this._items.distance.container);
		this._preventAnimation = false;
	}

	get container() {
		return this._container;
	}

	set preventAnimation(preventAnimation: boolean) {
		this._preventAnimation = preventAnimation;
	}

	set summary(summary: ISummary) {
		const seconds = parseFloat(summary.total_time) ? parseFloat(summary.total_time) : 0;
		const count = parseFloat(summary.total_count) ? parseFloat(summary.total_count) : 0;
		const meters = parseFloat(summary.total_length) || 0;

		let secondInt = null;
		let countInt = null;
		let distanceInt = null;
		let secondsActual = 0;
		let countActual = 0;
		let distanceActual = 0;

		const time = standardTimeFormat(seconds, true);

		this._items.time.value.innerHTML = time.time;
		this._items.time.unit.innerHTML = _(`time.full.${time.key}`);
		this._items.count.value.innerHTML = count.toString();

		const distance = standardDistanceFormat(meters.toString());

		this._items.distance.value.innerHTML = Math.round(distance.distanceNumber).toString();
		this._items.distance.unit.innerHTML = distance.unit;

		if (!this._preventAnimation) {
			if (seconds > 0) {
				secondInt = setInterval((con, unitCon) => {
					secondsActual += Math.floor(seconds / (seconds > 100 ? 100 : seconds));
					const formatTime = standardTimeFormat(secondsActual, true);

					con.innerHTML = formatTime.time;
					unitCon.innerHTML = _(`time.full.${formatTime.key}`);
					if (secondsActual >= seconds) {
						con.innerHTML = time.time;
						unitCon.innerHTML = _(`time.full.${time.key}`);
						clearInterval(secondInt);
					}
				}, 10, this._items.time.value, this._items.time.unit);
			}

			if (count > 0) {
				countInt = setInterval(container => {
					countActual += Math.floor(count / (count > 100 ? 100 : count));
					container.innerHTML = countActual.toString();
					if (countActual >= count) {
						container.innerHTML = count.toString();
						clearInterval(countInt);
					}
				}, 10, this._items.count.value);
			}

			if (distance.distanceNumber > 0) {
				distanceInt = setInterval(container => {
					distanceActual += Math.floor(distance.distanceNumber / (distance.distanceNumber > 100 ? 100 : distance.distanceNumber));
					container.innerHTML = distanceActual.toString();
					if (distanceActual >= distance.distanceNumber) {
						container.innerHTML = Math.floor(distance.distanceNumber).toString();
						clearInterval(distanceInt);
					}
				}, 10, this._items.distance.value);
			}
		}
	}
}
